module.exports = () => {
  return {
    name: {
      label: '模板名称',
      type: 'label',
      value: '-',
    },
    advertiser: {
      label: '广告主账户',
      type: 'label',
      value: '-',
    },
    advertiser_source: {
      label: '模板来源',
      type: 'label',
      value: '-',
    },
    anchor_type: {
      label: '锚点类型',
      type: 'label',
      value: '-',
    },
    game_type: {
      label: '推广内容',
      type: 'label',
      value: '-',
    },
    platform_type: {
      label: '配置平台',
      type: 'label',
      value: '-',
    },
    android_download_url: {
      label: '安卓下载链接',
      type: 'label',
      hidden: false,
      value: '',
    },
    android_anchor_title: {
      label: '安卓端锚点标题',
      type: 'label',
      hidden: false,
      value: '',
    },
    ios_download_url: {
      label: 'iOS下载链接',
      type: 'label',
      hidden: false,
      value: '',
    },
    ios_anchor_title: {
      label: 'iOS端锚点标题',
      type: 'label',
      hidden: false,
      value: '',
    },
    app_tags: {
      label: '游戏标签',
      type: 'label',
      value: '-',
    },
    guide_text: {
      label: '引导文案',
      type: 'label',
      value: '-',
    },
    game_description: {
      label: '游戏简介',
      type: 'label',
      value: '-',
    },
    game_charatoristic: {
      label: '游戏特色',
      type: 'label',
      value: '-',
    },
    other_description: {
      label: '其他说明',
      type: 'label',
      value: '-',
    },
    game_bonus: {
      label: '游戏福利',
      type: 'label',
      value: '-',
    },
  };
};
